import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

// Moved from features/billingSettings/BillingSettingsSlice.js. Real bug
// fixed: the old slice's initialState declared {billingSettings, bsMode},
// but its reducers actually wrote state.flows and state.mode/state.bsMode -
// the declared shape never matched the shape after any dispatch, see
// docs/bug-sheet.md. Also genuinely dead weight dropped, not carried
// forward: `flows` (written by the old setBillingSettings, but nothing
// anywhere in the repo ever read state.billingSettings.flows via
// useSelector - confirmed via grep) and `bsMode` (written alongside `mode`
// on every dispatch, but nothing ever read it either - only `mode` is read,
// by the 12 node components). `mode` is the one field with real readers, so
// it's the only state this slice kept.
//
// `selectedFilters` added for the list page's toolbar (Filters/Search/Sort)
// - same shape/REHYDRATE-safety as _features/roles/state/slice.js.
const DEFAULT_SORT = "-id";

const initialState = { mode: "", selectedFilters: { sort: DEFAULT_SORT } };

const billingLogicSlice = createSlice({
  name: "billingLogic",
  initialState,
  reducers: {
    setMode(state, action) {
      state.mode = action.payload;
    },
    updateSelectedFilters(state, action) {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters(state) {
      state.selectedFilters = { sort: DEFAULT_SORT };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.billingLogic) {
        const persistedFilters = action.payload.billingLogic.selectedFilters;

        return {
          ...state,
          selectedFilters: {
            ...(persistedFilters && typeof persistedFilters === "object" ? persistedFilters : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { setMode, updateSelectedFilters, resetSelectedFilters } = billingLogicSlice.actions;
export default billingLogicSlice.reducer;
